module.exports = __webpack_public_path__ + "img/mai.e9f38a42.png";